import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import Swal from 'sweetalert2'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import Vuex from 'vuex'
Vue.use(VueLocalStorage)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serverUrl: 'https://api-enterprise.zwiz.app/',
    query: {},
    profile: {},
    regisData: null,
    regiscount: Vue.localStorage.get('regiscount') ? Vue.localStorage.get('regiscount') : 0,
    regiscountTime: Vue.localStorage.get('regiscountTime')
      ? Vue.localStorage.get('regiscountTime')
      : null,
    contactSelect: null,
    sourceSelect: 'ncap',
    userData: null,
    ref: null,
    checkOtp: false,
    changePhoneObj: {
      phone: null
    },
    selectContact: '',
    authorizeData: {
      idCard: '',
      dobDay: '',
      dobMonth: '',
      dobYear: '',
      nextCard: '000000000',
      faceImage: [],
      idcardImage: []
    },
    formatAuthorizeData: null,
    changePhoneMethod: '',
    selectAddress: null,
    addressType: '',
    hasRegisteredAccount: false,
    hasEtaxBill: false,
    regisList: {
      version: {
        hpmc: null,
        mkt: null,
        mktPdpa: null,
        tc: null,
        nmPp: null,
        nmMkt: null,
        nmMktPdpa: null
      },
      answer: {
        hpmc: null,
        mkt: null,
        mktPdpa: null,
        tc: null,
        nmPp: null,
        nmMkt: null,
        nmMktPdpa: null
      }
    }
  },
  mutations: {
    ['REGIS_LIST'](state, payload) {
      // mutate state
      state.regisList = payload
    },
    ['CONTACT'](state, payload) {
      // mutate state
      state.contactSelect = payload
    },
    ['SOURCE'](state, payload) {
      // mutate state
      state.sourceSelect = payload
    },
    ['USER'](state, payload) {
      // mutate state
      state.userData = payload
    },
    ['REF'](state, payload) {
      // mutate state
      state.ref = payload
    },
    ['COUNT_REGIS'](state, count) {
      let temp = count
      state.regiscount = temp
      Vue.localStorage.set('regiscount', temp)
      if (temp > 4) {
        let dateNow = new Date()
        dateNow = moment(dateNow).format('DD MM YYYY HH mm')
        Vue.localStorage.set('regiscountTime', dateNow)
      }
    },
    setFormatAuthorizeData(state, payload) {
      state.formatAuthorizeData = payload
    },
    setChangePhoneMethod(state, value) {
      state.changePhoneMethod = value
    }
  },
  actions: {
    setRegisList({ commit }, payload) {
      commit('REGIS_LIST', payload)
    },
    conutRegis({ commit }, count) {
      commit('COUNT_REGIS', count)
    },
    setContact({ commit }, payload) {
      commit('CONTACT', payload)
    },
    setContactSource({ commit }, payload) {
      commit('SOURCE', payload)
    },
    setUserData({ commit }, payload) {
      commit('USER', payload)
    },
    setRefData({ commit }, payload) {
      commit('REF', payload)
    },
    sendMessage({ state }, message) {
      var vm = this
      return new Promise(async resolve => {
        var url = state.serverUrl + 'zwiz-pushmsg-webbrowser'
        var data = {
          pageid: config.pageid,
          userid: state.userid || state.query.userid,
          message
        }
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: 'text'
              }
            ])
            resolve()
          } catch (error) {
            alert(JSON.stringify(error))
            alert(JSON.stringify(error.message))
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: 'Bearer nextcapliffapi 6ckq6l3fz6yhy2ma6bytjc'
              }
            })
            .then(async response => {
              if (response.data.responsecode == 200) {
                resolve()
              } else {
                if (response.data.reason) {
                  await Swal.fire({
                    text: response.data.reason
                  })
                  resolve()
                }
              }
            })
        }
      })
    },
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() {},
        function error() {
          window.close()
        }
      )
    }
  },
  getters: {
    regisList: state => {
      return state.regisList
    },
    getLinkEtax: state => {
      // 1656443757-zMemYlQm == prod
      // 1661491509-V9DZNM45 == dev
      const eTaxLineLiff =
        config.pageid == '102549712095297' ? '1656443757-zMemYlQm' : '1661491509-V9DZNM45'
      let link = `https://liff.line.me/${eTaxLineLiff}/?userid=${state.profile.userId ||
        state.userid}__${config.pageid}&pageid=${config.pageid}`
      return link
    },
    getNMLinkEtax: state => {
      // 1656443757-zMemYlQm == prod
      // 1661491509-V9DZNM45 == dev
      const eTaxLineLiff =
        config.pageid == '102549712095297' ? '1656443757-oRkPrl8P' : '1656355405-e9vMd28M'
      let link = `https://liff.line.me/${eTaxLineLiff}/?userid=${state.profile.userId ||
        state.userid}__${config.pageid}&pageid=${config.pageid}`
      return link
    },
    getUserid: state => {
      return state.profile && state.profile.userId
        ? state.profile.userId
        : state.userid
        ? state.userid
        : null
    }
  },
  modules: {}
})
